var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28",
    "data-name": "Layer 28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 2v24h28v-24zm4 20 10-16 10 16z",
    fill: "#f4b2b0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b3404a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27 45h10v2h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 39h5v-2h-4v-2h4v-2h-4v-2h4v-2h-5a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 35h1.559a5.786 5.786 0 0 1 1.441 3.828v.172h2v-.172a7.77 7.77 0 0 0 -1.316-4.348 3 3 0 0 0 -1.684-5.48h-3a1 1 0 0 0 -1 1v9h2zm0-4h2a1 1 0 0 1 0 2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 35h1.559a5.786 5.786 0 0 1 1.441 3.828v.172h2v-.172a7.77 7.77 0 0 0 -1.316-4.348 3 3 0 0 0 -1.684-5.48h-3a1 1 0 0 0 -1 1v9h2zm0-4h2a1 1 0 0 1 0 2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 35h1.559a5.786 5.786 0 0 1 1.441 3.828v.172h2v-.172a7.77 7.77 0 0 0 -1.316-4.348 3 3 0 0 0 -1.684-5.48h-3a1 1 0 0 0 -1 1v9h2zm0-4h2a1 1 0 0 1 0 2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 39h1a3 3 0 0 0 3-3v-4a3 3 0 0 0 -3-3h-1a3 3 0 0 0 -3 3v4a3 3 0 0 0 3 3zm-1-7a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 7h-11v-5a1 1 0 0 0 -1-1h-28a1 1 0 0 0 -1 1v5h-11a5.006 5.006 0 0 0 -5 5v34a5.006 5.006 0 0 0 5 5h21v4h-3a7.008 7.008 0 0 0 -7 7 1 1 0 0 0 1 1h28a1 1 0 0 0 1-1 7.008 7.008 0 0 0 -7-7h-3v-4h21a5.006 5.006 0 0 0 5-5v-34a5.006 5.006 0 0 0 -5-5zm-39-4h26v22h-26zm-13 6h11v17a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1v-17h11a3 3 0 0 1 3 3v29h-58v-29a3 3 0 0 1 3-3zm38.9 52h-25.8a5.008 5.008 0 0 1 4.9-4h16a5.008 5.008 0 0 1 4.9 4zm-9.9-6h-6v-4h6zm23-6h-52a3 3 0 0 1 -3-3v-3h58v3a3 3 0 0 1 -3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.848 5.47a1.04 1.04 0 0 0 -1.7 0l-10 16a1 1 0 0 0 .852 1.53h20a1 1 0 0 0 .848-1.53zm-9.048 15.53 8.2-13.113 8.2 13.113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 11h2v5h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 17h2v2h-2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.5b07ff37ecacd7170dfbc31d483fcd48.svg";
export { ForwardRef as ReactComponent };